import React, { useState } from 'react';
import { Box, Paper, TextField, Button, Typography, Alert, FormControlLabel, Checkbox } from '@mui/material';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import { useAuth } from '../contexts/AuthContext';
import { isStandalone } from '../services/push';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  // En la app instalada se mantiene la sesion por defecto; en un ordenador, no
  const [remember, setRemember] = useState(isStandalone());
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password, remember);
    } catch (err) {
      const msg = err.response?.data?.detail || 'Error al iniciar sesion';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#ffebee',
    }}>
      <Paper sx={{ p: 4, maxWidth: 400, width: '100%' }} elevation={3}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <PrecisionManufacturingIcon color="primary" sx={{ fontSize: 48 }} />
          <Typography variant="h5" fontWeight="bold" color="primary">
            GPI
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Gestor de Proyectos Industriales
          </Typography>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={{ mb: 2 }}
            autoFocus
          />
          <TextField
            fullWidth
            label="Contrasena"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={{ mb: 1 }}
          />
          <FormControlLabel
            sx={{ mb: 2 }}
            control={<Checkbox checked={remember} onChange={(e) => setRemember(e.target.checked)} />}
            label="Mantener la sesion iniciada en este dispositivo"
          />
          <Button
            fullWidth
            variant="contained"
            type="submit"
            size="large"
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Iniciar Sesion'}
          </Button>
        </form>

        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Button size="small" href="/tecnicos" sx={{ textTransform: 'none' }}>
            Soy tecnico
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
